import { render } from "./TodoClearButton.vue?vue&type=template&id=9b6eef5c"
import script from "./TodoClearButton.vue?vue&type=script&lang=js"
export * from "./TodoClearButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__